export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12907.7e68ea01.jpg";